import { TypedActionWithPayload } from '@/types/redux';

export const LOGIN_FAIL = 'LOGIN_FAIL';
export type LOGIN_FAIL_ACTION = TypedActionWithPayload<typeof LOGIN_FAIL>;

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export type LOGIN_REQUEST_ACTION = TypedActionWithPayload<typeof LOGIN_REQUEST>;

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export type LOGIN_SUCCESS_ACTION = TypedActionWithPayload<typeof LOGIN_SUCCESS>;
